import React, {Component} from 'react';
import {NavLink, withRouter} from 'react-router-dom';
import {inject, observer} from 'mobx-react';
// import HttpClient from 'services/HttpClient';
import classNames from 'classnames';
// import {TOPIC_TYPE_NAME} from 'constants/topicTypes';
// import {Logo} from '../components/Logo';
import Logo from '../../../images/landing/Logo.svg';
import logo from '../../../images/Logo.png';
import sign from '../../../images/rayan.png';

// const TOPICS_REQUEST = '/api/v1/tutorials/';

@withRouter
@inject('sideBarStore')
@inject('userStore')
@inject('headerStore')
@inject('examPrepHeaderStore')
@observer
class ExamPrepHeader extends Component {
  componentWillMount() {
    const {examPrepHeaderStore} = this.props;

    examPrepHeaderStore.clear();
    window.addEventListener('scroll', this.handleScroll);
  }

  handleSidebar = () => {
    this.props.sideBarStore.activate();
  };

  handleIsLanding = (location) => {
    return location.pathname === '/' || location.pathname === '/pricing';
  };

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    if(this.props.location.pathname === '/' || this.props.location.pathname === '/pricing') {
      // const el = document.getElementsByClassName('landing');
      const sectionEl = document.getElementsByClassName('section');
      const elPos = sectionEl[0].getBoundingClientRect();
      const wasScrolled = this.props.headerStore.isScrolled;

      if((elPos.top < -5) && !wasScrolled) {
        this.props.headerStore.scrolled();
      }

      if((elPos.top > -5) && wasScrolled) {
        this.props.headerStore.scrolled();
      }
    }
  };

  renderButtons = (topic) => {
    return (
      <div className='navbar-exam-prep'>
        <NavLink className="margin-left-20" to={`/exam-prep/topic/${topic.id}`}>
          {topic.title}
        </NavLink>
        <NavLink className="margin-left-20" to={`/exam-prep/${topic.id}/topics`}>
          Clinical Topics
        </NavLink>
        <NavLink className="margin-left-20" to={`/exam-prep/${topic.id}/resources`}>
          OSCEs
        </NavLink>
        <NavLink className="margin-left-20" to={`/exam-prep/${topic.id}/mcq`}>
          MCQs
        </NavLink>
        <NavLink className="margin-left-20" to={`/exam-prep/${topic.id}/clinical-notes-writing`}>
          Clinical Notes Writing
        </NavLink>
      </div>
    );
  };

  handleShowButtons = (topic, showButtons) => {
    const {isSubscribed} = this.props.userStore;

    if (showButtons || isSubscribed) {
      return this.renderButtons(topic);
    }

    return null;
  };

  render() {
    const {location, userStore, examPrepHeaderStore} = this.props;
    const {topic, showButtons} = examPrepHeaderStore;
    const activeSearch = this.props.headerStore.isActiveSearch;
    const wasScrolled = this.props.headerStore.isScrolled;

    return (
      <header className={classNames('main-header fixed-top', {
        'landing-header': this.handleIsLanding(location) && !userStore.user,
        'is-scrolling': wasScrolled
      })}>
        <div className="container-fluid">
          <div className="row align-items-center justify-content-between no-wrap">
            <div className="col-5 col-sm-4 col-md-2">
              <div
                className={classNames('logo', {'searchActive': activeSearch})}
                // to={userStore.user ? '/' : '/'}
              >
                <img src={Logo} />
                <img src={logo} style={{ visibility: 'hidden', width: 0, height: 0 }} />
                <img src={sign} style={{ visibility: 'hidden', width: 0, height: 0 }} />
              </div>
            </div>
            <div className='row header-links'>
              {!userStore.isSubscribed && (
                <NavLink to="/">Dashboard</NavLink>
              )}
              {this.handleShowButtons(topic, showButtons)}
              <NavLink className="margin-left-20" to="/settings">My Account</NavLink>
            </div>

            <div className="mob-burger">
              <div className="header-left-holder">
                <i onClick={this.handleSidebar}
                   className="ic ic-burger menu"/>
              </div>
            </div>
          </div>
        </div>
      </header>
    )
  }
}

export default ExamPrepHeader;



// WEBPACK FOOTER //
// ./src/modules/core/containers/ExamPrepHeader.js